<template>


    <div id='page'>   
		<div data-height="85" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="85" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="85" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>OTs Vencidas</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
<a  href="#" class="bg-green1-dark color-red2-dark" style="display:none; border:0;height:30px;position:relative;left:80%;top:0px;font-size:9px">{{ index }}</a>

    	<div id='content1'>   

			<div class="calendar">
				<div class="search-box search-color bg-green1-dark shadow-tiny round-huge bottom-0">
					<i class="fa fa-search"></i>
					<input type="text" v-model="datasearch" @keyup="datasearchfx" placeholder="Buscar por patente y/o cliente" data-search>
				</div>
			</div>

			<div class="divider bottom-15"></div>
			<div class="content-boxed">
				<div v-for="(a, index) in agenda" class="content">
					<div class="user-list-slider bottom-0">
						<div class="user-list-right">
							<h4>{{ a.fecha }} {{ a.hora }} {{ a.CLIENTEAGENDA }}</h4>
							<p class="color-red2-dark" style="font-size:1.5em">{{ a.PLACAPATENTE}}</p>
							<a v-if="a.IN_COD_COTIZACIONVEHICULO" href="#" @click="setpreorden(a.IN_COD_COTIZACIONVEHICULO,a.IN_COD_USUARIOAGENDA,a.fecha,a.hora)" class="next-slide-user fa-1x bg-green1-dark" style="display:'none';width:150px;top:40px">OT N° {{ a.IN_COD_COTIZACIONVEHICULO }}</a>
							<span v-if="a.IN_COD_COTIZACIONVEHICULO" class="next-slide-user fa-1x bg-green1-dark" style="width:150px;top:40px">{{ a.ESTADO }} N° {{ a.IN_COD_COTIZACIONVEHICULO }}</span>
						</div>
					</div>   

					<div class="divider"></div>

				
				</div>
			<br>
			</div>   
    	</div>

		
    </div>


</template>

<script>

import * as db from "./../../database.js";

export default {
    data() {
      return {
		mescalendario:"",
		datasearch:"",
		codsucursal:0,
		sucursal:"",
        agenda: [],
        calendario: [],
		response: "",
		vercalendario:false

      }
    },

	created() {      
		//alert(LstrFecha);
		this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")"  
		this.idcotizacionvehiculo=0;
		this.idagenda=0;
		this.datasearchfx();	
	},


  methods: {
	datasearchfx()
	{
	let codsucursal=JSON.parse(localStorage.getItem('user')).codsucursal;
	let codusuario=JSON.parse(localStorage.getItem('user')).codusuario;
	db.getFx("agenda.seleccionhora",'{"datasearch":"'+this.datasearch+'","codsucursal":"'+codsucursal+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
		console.log(result.data.data)
		this.agenda=result.data.data
		}});

	},

	setpreorden(idcotizacionvehiculo,idagenda,fecha,hora) {
			localStorage.setItem('idcotizacionvehiculo',idcotizacionvehiculo)
			localStorage.setItem('idagenda',idagenda)
			localStorage.setItem('fechaagenda',fecha)
			localStorage.setItem('horaagenda',hora)
			window.location="/Wizardot1show"
	},

	
  }


}
</script>
